import React, { useState } from 'react';
import { MenuItem } from 'rc-menu';
import {
  WrappedEvent,
  unifiedStopPropagation,
} from '../../../../util/unifiedStopPropagation';
import styles from './DropdownItem.module.scss';
import { DeleteConfirmationControls } from '../DeleteConfirmationControls';
import { DropdownComponentProps } from '../types';

const noClick = {
  color: '#ccc',
  backgroundColor: 'white',
  cursor: 'default',
};

export const DropdownItemStatic: React.FC<DropdownComponentProps> = ({
  item,
  itemLevel: _itemLevel, // rc-menu should not extrapolate it on the underlying `li` element to avoid warnings.
  ...props
}) => (
  <MenuItem {...props} style={noClick}>
    {item.title()}
  </MenuItem>
);
DropdownItemStatic.displayName = 'DropdownItemStatic';

export const DropdownItemWithActionConfirmation: React.FC<
  DropdownComponentProps
> = ({
  item,
  itemLevel: _itemLevel, // rc-menu should not extrapolate it on the underlying `li` element to avoid warnings.
  ...props
}) => {
  const [isControlsShown, setIsControlsShown] = useState(false);

  const handleHideControls = () => setIsControlsShown(false);

  const handleClick = (e: WrappedEvent) => {
    unifiedStopPropagation(e);
    setIsControlsShown(true);
  };

  return (
    <MenuItem
      {...props}
      className={item.isDisabled() ? styles.disabled : ''}
      onClick={handleClick}
    >
      {isControlsShown ? (
        <DeleteConfirmationControls
          item={item}
          onHideControls={handleHideControls}
        />
      ) : (
        item.title()
      )}
    </MenuItem>
  );
};
DropdownItemWithActionConfirmation.displayName =
  'DropdownItemWithActionConfirmation';

export const DropdownItem: React.FC<DropdownComponentProps> = ({
  item,
  itemLevel: _itemLevel, // rc-menu should not extrapolate it on the underlying `li` element to avoid warnings.
  ...props
}) => {
  const onClick = (e: WrappedEvent) => {
    if (item.isNoClose()) {
      unifiedStopPropagation(e);
    }

    if (item.isDisabled()) return null;

    item.onAction(e.domEvent);
  };

  return (
    <MenuItem
      {...props}
      className={item.isDisabled() ? styles.disabled : ''}
      onClick={onClick}
    >
      {item.title()}
    </MenuItem>
  );
};
DropdownItem.displayName = 'DropdownItem';
